import React, { useRef } from "react";
import {
  CODE_PANE_MIN_WIDTH,
  DIAGRAM_MIN_WIDTH,
  clampSplitPaneWidth,
  useSplitPaneResize,
} from "../../../../hooks/useSplitPaneResize";
import { ResizeHandle } from "../../agentChatLayoutConstants";
import "./WorkflowCodeView.css";

export { CODE_PANE_MIN_WIDTH, DIAGRAM_MIN_WIDTH };
export const clampCodePaneWidth = clampSplitPaneWidth;

export default function WorkflowCodeSplitView({ open, codePane, children }) {
  const containerRef = useRef(null);
  const { leadingWidth: codeWidth, onResizeStart } = useSplitPaneResize({
    containerRef,
    enabled: open,
  });

  return (
    <div
      ref={containerRef}
      className="workflow-code-split"
      data-testid="workflow-code-split"
    >
      {open && (
        <>
          <div
            className="workflow-code-split__code"
            style={{ width: codeWidth ?? "50%" }}
          >
            {codePane}
          </div>
          <ResizeHandle onMouseDown={onResizeStart} />
        </>
      )}
      <section
        className="workflow-code-split__diagram"
        aria-label="Workflow diagram"
      >
        {open && (
          <header className="workflow-code-split__diagram-header">
            Diagram
          </header>
        )}
        <div className="workflow-code-split__diagram-content">{children}</div>
      </section>
    </div>
  );
}
